import { render, staticRenderFns } from "./txStatus.vue?vue&type=template&id=7e56c1f9&scoped=true&"
import script from "./txStatus.vue?vue&type=script&lang=ts&"
export * from "./txStatus.vue?vue&type=script&lang=ts&"
import style0 from "./txStatus.vue?vue&type=style&index=0&id=7e56c1f9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e56c1f9",
  null
  
)

export default component.exports